<template>
  <tuango-portlet class="box blue">
    <div slot="title" class="portlet-title">
      <div slot="caption" class="caption">
        <i class="icon-link"></i>
        <slot>Claims</slot>
      </div>
      <div slot="actions" class="actions">
      </div>
    </div>
    <div slot="body">
      <tuango-datatables :tableData="claims"
                         :headers="headers"
                         :buttons="buttons"></tuango-datatables>
    </div>
  </tuango-portlet>
</template>

<script>
  import TuangoDatatables from '@/app/components/datatables/Datatable'
  import TuangoPortlet from '@/app/components/Portlet'

  export default {
    name: 'table-trx',
    props: {
      claims: {
        type: Array,
        required: true
      },
      cards: {
        type: Array,
        required: true
      }
    },
    components: {
      TuangoDatatables,
      TuangoPortlet
    },
    data () {
      return {
        headers: [
          {
            prop: 'offerId',
            title: 'Offer ID'
          },
          {
            prop: 'offerTitle',
            title: 'Offer Title'
          },
          {
            prop: 'date',
            title: 'Link Date'
          },
          {
            prop: 'redeemExpiresTime',
            title: 'Redeem Expiration Date'
          },
          {
            prop: 'claimEmailBtn',
            title: 'Actions'
          }
        ],
        buttons: [
          {
            extend: 'copy',
            className: 'dt-button btn default'
          },
          {
            extend: 'print',
            className: 'dt-button btn default'
          },
          {
            extend: 'csv',
            className: 'dt-button btn default'
          }
        ]
      }
    },
    methods: {
      resendClaimNotification (e) {
        e.preventDefault()
        const $el = $(e.target)

        this.$api.resendclaimemailCustIdOfferIdPost(
          {
            cust_id: $el.data('customer'),
            offer_id: $el.data('offer')
          },
          {
            cards: this.cards,
            redeemExpiresTime: $el.data('expires')
          }
        )
          .then(res => {
            this.$notify.success({
              title: 'Success',
              message: 'Claim notification email successfully sent'
            })
          })
          .catch(err => {
            console.log(err)
            this.$notify.error({
              title: 'Error',
              message: 'Error occured'
            })
          })
      }
    },
    mounted () {
      $('[data-action="resendClaimEmail"]').on('click', this.resendClaimNotification)
    },
    beforeDestroy () {
      $('[data-action="resendClaimEmail"]').off('click', this.resendClaimNotification)
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/user/Claims.vue